import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import {
  IOperatorTail,
  IOperatorTailForm,
} from 'src/models/operator-tail.model';
import { useOperatorTailContext } from 'src/contexts/operator-tail.context';
import Lang from 'src/libraries/language';
import { getOperatorTailStatus } from 'src/selectors/operator-tail.selector';
import { actionTypes } from 'src/ducks/operator-tail.duck';
import OperatorTailsForm from '../operator-tail-number-relationship-form/operator-tail-number-relationship-form.component';
import style from '../operator-tail-number-relationship-list/operator-tail-number-relationship-list.module.scss';

type IProp = {
  data: IOperatorTail;
};

const OperatorTailsEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useOperatorTailContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues: Partial<IOperatorTailForm> = {
    operatorId: data.Operator?.operatorId,
    tailId: data.TailNumber?.tailId,
  };

  const editStatus = getOperatorTailStatus(
    state,
    actionTypes.OPERATOR_TAIL_NUMBER_UPDATE
  );

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (formData) => {
      const response = await actions.updatePUT(data.otId, formData);

      if (!response.error) {
        ToastSuccess(Lang.MSG_OPERATOR_TAIL_NUMBER_EDIT_SUCCESS);
      } else {
        ToastError(response.error.message);
      }

      setIsEditOpen(false);
      actions.listGET();
    },
    [data, actions, setIsEditOpen]
  );

  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => setIsEditOpen(true)}
        />
      }
      header={Lang.LBL_MODIFY_OPERATOR_TAIL_NUMBER}
      content={
        <div className={style.content}>
          <OperatorTailsForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || editStatus.fetching}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default OperatorTailsEdit;
